/**
 * Autenticación del handshake WebSocket.
 *
 * El access token viaja en `Sec-WebSocket-Protocol: bearer, <jwt>` y nunca en la
 * URL: la query string (`?token=`) queda registrada en los logs de request de
 * Cloud Run y de cualquier proxy intermedio. El backend responde el
 * subprotocolo `bearer`, que el navegador acepta porque está en la lista ofrecida.
 */
export const WS_BEARER_PROTOCOL = "bearer";

export function wsAuthProtocols(token: string): string[] {
  return [WS_BEARER_PROTOCOL, token];
}
